import { Content } from "@patternfly/react-core";
import type { FC } from "react";
import SupportIcon from "../../../assets/Icon-Red_Hat-Support-A-Red-RGB.png";
import type { DragHandleProps } from "../../../constants/CardsStructure";
import Env from "../../../utils/env";
import { DashboardCard } from "../shared/DashboardCard";

export const SupportCard: FC<{ dragHandleProps?: DragHandleProps | undefined }> = ({ dragHandleProps }) => {
	const SupportCardBody: FC = () => (
		<Content>
			<Content component="p">
				The Red Hat Partner Acceleration Desk (PAD) is available to partners to ask questions about topics including
				account access, onboarding, subscriptions, partner programs, product certification, and more.
			</Content>
		</Content>
	);

	return (
		<DashboardCard
			icon={SupportIcon}
			title="Connect with partner support"
			isLoading={false}
			cardBody={<SupportCardBody />}
			primaryAction={{
				label: "Get assistance",
				href: `${Env.ConnectPortalUrls[Env.getEnvName()]}support/partner-acceleration-desk/`,
			}}
			footerLinks={[
				{ label: "Open a support case", href: `${Env.AccessRedhatPortals[Env.getEnvName()]}support/cases/#/case/new` },
				{ label: "My support cases", href: `${Env.AccessRedhatPortals[Env.getEnvName()]}support/cases/` },
			]}
			dragHandleProps={dragHandleProps}
		/>
	);
};
